<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="home"></ion-back-button>
    </ion-buttons>
    <ion-title>Download iOnCourt App</ion-title>
    <ion-buttons slot="end">
      <ion-button [routerLink]="['/login']" routerLinkActive="router-link-active">
        Log in
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="content-width ion-text-center" style="margin-top: 25px;">
    <ion-row>
      <ion-col size="12" (click)="openAppStore()">
          <ion-img src="../assets/img/apple-app-store-en.svg"></ion-img>
      </ion-col>
      <ion-col size="12" (click)="openPlayStore()">
          <ion-img src="../assets/img/google-play-en.png"></ion-img>
      </ion-col>
      <ion-col size="12">
        <ion-button style="margin: 25px;" (click)="openSocial('linkedin')" expand="block">
          <ion-icon slot="start" name="logo-linkedin"></ion-icon> LinkedIn
        </ion-button>
      </ion-col>
    </ion-row>
  </div>

</ion-content>